<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
<main>

  <app-headline-section
    [title]="airline()? airline().airline_possessive + ' Workflows':''">
  </app-headline-section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <p class="cl-p-large">Efficiently manage and track your POs in one user-friendly interface. </p>
        </div>
      </div>
    </div>
  </section>
  <app-filter-section [all]="allpos$()" [filtered]="pos$()" [formGroup]="filters" [openByDefault]="(allpos$() || []).length > 5">
    <form [formGroup]="filters" class="cl-form">
      <div class="row g-3 align-items-start">
        <div class="col mt-0">
          <input type="text" class="form-control" style="width: 100%" formControlName="t"
            placeholder="Search by name and path" autofocus>
          <p class="valid-feedback">Search terms are case-insensitive.</p>
        </div>
        <div class="col-3 mt-0">
          <select formControlName="targetSystem" class="form-select">
            <option value="" selected>[All target systems]</option>
            @for (system of targetSystems$(); track system) {
              <option [value]="system">{{ system }}</option>
            }
          </select>
          <p class="valid-feedback">Filter by target system</p>
        </div>
        <div class="col-2 mt-0">
          <select formControlName="year" class="form-select">
            <option [ngValue]="null">[All years]</option>
            @for (year of years; track year) {
              <option [value]="year">{{ year }}</option>
            }
          </select>
          <p class="valid-feedback">Filter by year</p>
        </div>
      </div>
    </form>
  </app-filter-section>
  <section class="cl-section cl-section-regular">


    <div class="container">
      <div class="row">
        <div class="col-12">
          <table style="table-layout: fixed;" class="cl-table-data">
            <thead>
              <tr>
                <th class="cl-table-head cl-p-tiny " style="max-width: 50%; min-width: 100px">
                  PO
                </th>
                <th class="cl-table-head cl-p-tiny " style="width: 180px">
                  Order Date
                </th>
                <th class="cl-table-head cl-p-tiny " style="width: 120px">
                  Finalized
                </th>
                <th class="cl-table-head cl-p-tiny " style="max-width: 50%">
                  Target system
                </th>
              </tr>
            </thead>
            <tbody>



              @if (!loading()) {
                <tr>
                  <td>
                    @if (!(poprefix$ | async)) {
                      <a [routerLink]="['/o', this.organization()?.id, 'workflows']">.. (up)</a>
                    }
                    @if (poprefix$ | async) {
                      <a
                      [routerLink]="['/o', this.organization()?.id, 'workflows', this.airline()?.iata_code]">.. (up)</a>
                    }
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              }
              @if (loading()) {
                <tr class="cl-tr-no-data">
                  <td colspan="4" style="text-align: center">
                    <div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i>
                  </div>
                </td>
              </tr>
            }
            @for (element of pos$(); track element) {
              <tr>
                <td>
                  <a [routerLink]="['/o', this.organization().id, 'workflows', airline()?.iata_code, element.po_name ]"
                    [queryParams]="{ prefix: poprefix$ | async }">
                  {{ element.po_name  | orgResolver }}</a>
                </td>
                <td>{{ element.date_created | cldate }}</td>
                <td> @if (element.finalized) {
                  <i class="fas fa-check"></i>
                }</td>
                <td>
                  @if (element.target_system && element.target_system.split(',').length > 5) {
                    <span [title]="element.target_system">Various ({{ element.target_system.split(',').length }})</span>
                  } @else {
                    {{ element.target_system }}
                  }
                </td>
              </tr>
            }

          </tbody>

        </table>
      </div>
    </div>

  </div>

</section>
</main>
